// import './App.css';
// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Home from './pages/Home';
// import About from './pages/About';
// import Services from './pages/Services';
// import GSTServices from './pages/GSTServices';
// import Media from './pages/Media';
// import Careers from './pages/Careers';
// import Blog from './pages/Blog';
// import ContactUs from './pages/ContactUs';
// import MyAccount from './pages/MyAccount';
// import BigDataSolution from "./pages/Bigdatasolution";
// import Footer from './components/Footer';
// import BankDataSolution from './pages/BankDataSolution';
// import GstReconciliation from "./pages/GstReconciliation";
// import CyberForensic from "./pages/CyberForensic";
// import CallAnalytics from "./pages/CallAnalytics";
// import DigitalMarket from './pages/DigitalMarket';
// import PopupForm from './pages/PopupForm';
// import PrivateRoute from "./components/PrivateRoute";
// import LoginMessage from "./components/LoginMessage";
// import CyberSecurity from "./pages/CyberSecurity";
// import AdminReview from "./pages/AdminReview";
// import RBIChatbot from './components/RBIChatbot';
// import VendorForm from './pages/VendorForm';

// function App() {
//   return (
//     <Router>
//       <Navbar />
//       <RBIChatbot />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/gst-services" element={<GSTServices />} />
//         <Route path="/media" element={<Media />} />
//         <Route path="/careers" element={<Careers />} />
//         <Route path="/blog" element={<PrivateRoute><Blog /></PrivateRoute>} />
//         <Route path="/contact-us" element={<ContactUs />} />
//         <Route path="/my-account" element={<MyAccount />} />
//         <Route path="/big-data-solution" element={<BigDataSolution />} />
//         <Route path="/bank-data-solution" element={<BankDataSolution />}/>
//         <Route path="/gst-reconciliation" element={<GstReconciliation />} />
//         <Route path="/cyber-forensic" element={<CyberForensic />} />
//         <Route path="/call-analytics" element={<CallAnalytics />} />
//         <Route path="/cyber-security" element={<CyberSecurity />} />
//         <Route path="/login-message" element={<LoginMessage />}/>
//         <Route path="/admin-review" element={<AdminReview />} />
//         <Route path="/digital-market" element={<DigitalMarket/>} />
//         <Route path="/vendor-form" element={<VendorForm />} />
//       </Routes>
//       <div>
//         <Footer/>
//       </div>
//     </Router>
//   );
// }

// export default App;


import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import GSTServices from './pages/GSTServices';
import Media from './pages/Media';
import Careers from './pages/Careers';
import Blog from './pages/Blog';
import ContactUs from './pages/ContactUs';
import MyAccount from './pages/MyAccount';
import BigDataSolution from "./pages/Bigdatasolution";
import Footer from './components/Footer';
import BankDataSolution from './pages/BankDataSolution';
import GstReconciliation from "./pages/GstReconciliation";
import CyberForensic from "./pages/CyberForensic";
import CallAnalytics from "./pages/CallAnalytics";
import DigitalMarket from './pages/DigitalMarket';
import PopupForm from './pages/PopupForm';
import PrivateRoute from "./components/PrivateRoute";
import LoginMessage from "./components/LoginMessage";
import CyberSecurity from "./pages/CyberSecurity";
import AdminReview from "./pages/AdminReview";
import VendorForm from './pages/VendorForm';
import IBChatbot from './pages/IBChatbot';
import DBHChatbot from './pages/DBHChatbot';

// ✅ Make sure this is a default import!
import RBIChatbot from './components/RBIChatbot'; 

function App() {
  return (
    <Router>
      <Navbar />

      {/* ✅ Chatbot only renders if it's not undefined or broken */}
      {/* {RBIChatbot ? <RBIChatbot /> : null}  */}
      {/* {DBHChatbot ? <DBHChatbot /> : null} */}
       <DBHChatbot />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/services" element={<Services />} />
        <Route path="/gst-services" element={<GSTServices />} /> */}
        <Route path="/media" element={<Media />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/blog" element={<PrivateRoute><Blog /></PrivateRoute>} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/big-data-solution" element={<BigDataSolution />} />
        <Route path="/bank-data-solution" element={<BankDataSolution />} />
        <Route path="/gst-reconciliation" element={<GstReconciliation />} />
        <Route path="/cyber-forensic" element={<CyberForensic />} />
        <Route path="/call-analytics" element={<CallAnalytics />} />
        <Route path="/cyber-security" element={<CyberSecurity />} />
        <Route path="/login-message" element={<LoginMessage />} />
        <Route path="/admin-review" element={<AdminReview />} />
        <Route path="/digital-market" element={<DigitalMarket />} />
        <Route path="/vendor-form" element={<VendorForm />} />
        <Route path="/IBChatbot" element={<IBChatbot />} />
        <Route path="/RBIChatbot" element={<RBIChatbot />} />
        {/* <Route path="/DBHChatbot" element={<DBHChatbot />} /> */}
        {/* Add more routes as needed */}
      </Routes>

      <Footer />
    </Router>
  );
}

  export default App;
